import React from "react";
import { Link, LinkProps } from "react-router-dom";
import styles from "./ButtonLink.module.css";

interface ButtonLinkProps extends Omit<LinkProps, "to"> {
  children: React.ReactNode;
  path: string;
}

export const ButtonLink = ({ path, children, ...props }: ButtonLinkProps) => {
  return (
    <Link to={path} className={styles.buttonLink} {...props}>
      {children}
    </Link>
  );
};
